module.exports = __webpack_public_path__ + "media/images/zl_title-44a3ae69b8ca0e4b9f05c14f9355d281.png";